import React from "react"

import { GatsbyImage, getImage } from "gatsby-plugin-image"

import { useTranslation, Link } from "@zestia/gatsby-plugin-react-i18next"
import SanityImage from "gatsby-plugin-sanity-image"
import GenericImage from "@/images/blog/generic-image.png"

const BlogPostPreview = ({ post }) => {
  const { t } = useTranslation()

  return (
    <Link className={`blog-post-preview`} to={post.frontmatter.slug}>
      <div className="blog-post-preview__image">
        {post.frontmatter.preview_image ? (
          post.internal.type === "SanityBlogPost" ? (
            <SanityImage
              {...post.frontmatter.preview_image}
              width={300}
              alt={post.frontmatter.title}
            />
          ) : (
            <GatsbyImage
              image={getImage(post.frontmatter.preview_image.src)}
              alt={post.frontmatter.title}
            />
          )
        ) : (
          <img src={GenericImage} alt={post.frontmatter.title} />
        )}
      </div>

      {/* Content */}
      <div className="blog-post-preview__content">
        <h2 className="mb-0 h5">{post.frontmatter.title}</h2>
      </div>
    </Link>
  )
}

export default BlogPostPreview
